import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { from, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SsoAuthService } from '../services/sso-auth.service';
import { isSafeRelativePath } from '../../shared/helpers/url.helpers';

const DEFAULT_AUTH_REDIRECT = '/dashboard';

export const ssoCallbackGuard: CanActivateFn = () => {
  const router = inject(Router);
  const ssoAuthService = inject(SsoAuthService);

  if (ssoAuthService.hasValidAccessToken()) {
    return of(resolvePostLoginRedirect(router, ssoAuthService));
  }

  return from(ssoAuthService.tryLogin()).pipe(
    map((loggedIn) => {
      if (loggedIn) {
        return resolvePostLoginRedirect(router, ssoAuthService);
      }

      return false;
    }),
    catchError((error: unknown) => {
      console.error(error);
      return of(false);
    }),
  );
};

function resolvePostLoginRedirect(router: Router, ssoAuthService: SsoAuthService) {
  const desiredPath = ssoAuthService.getPostLoginRedirectPath();

  if (desiredPath && isSafeRelativePath(desiredPath)) {
    return router.parseUrl(desiredPath);
  }

  return router.parseUrl(DEFAULT_AUTH_REDIRECT);
}
